import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Lazy load admin components for better initial load performance
const Login = lazy(() => import("./pages/admin/Login"));
const Dashboard = lazy(() => import("./pages/admin/Dashboard"));
const DashboardHome = lazy(() => import("./pages/admin/DashboardHome"));
const Settings = lazy(() => import("./pages/admin/Settings"));
const HeroEditor = lazy(() => import("./pages/admin/HeroEditor"));
const CompanyInfoEditor = lazy(() => import("./pages/admin/CompanyInfoEditor"));
const ServicesManager = lazy(() => import("./pages/admin/ServicesManager"));
const TestimonialsManager = lazy(() => import("./pages/admin/TestimonialsManager"));
const ClientsManager = lazy(() => import("./pages/admin/ClientsManager"));
const MediaManager = lazy(() => import("./pages/admin/MediaManager"));
const PressManager = lazy(() => import("./pages/admin/PressManager"));
const FAQsManager = lazy(() => import("./pages/admin/FAQsManager"));
const FormsManager = lazy(() => import("./pages/admin/FormsManager"));
const NurseryManager = lazy(() => import("./pages/admin/NurseryManager"));
const ProjectsManager = lazy(() => import("./pages/admin/ProjectsManager"));

// Loading fallback component
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
      <p className="text-slate-600">Carregant...</p>
    </div>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin/login" element={<Login />} />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardHome />} />
                <Route path="hero" element={<HeroEditor />} />
                <Route path="company-info" element={<CompanyInfoEditor />} />
                <Route path="services" element={<ServicesManager />} />
                <Route path="testimonials" element={<TestimonialsManager />} />
                <Route path="clients" element={<ClientsManager />} />
                <Route path="nursery" element={<NurseryManager />} />
                <Route path="projects" element={<ProjectsManager />} />
                <Route path="media" element={<MediaManager />} />
                <Route path="press" element={<PressManager />} />
                <Route path="faqs" element={<FAQsManager />} />
                <Route path="forms" element={<FormsManager />} />
                <Route path="settings" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
